import React, {Component} from "react";
import * as actions from '../../../store/actions';
// import { LinkContainer } from 'react-router-bootstrap';
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import TableRecord from "../../../Components/UI/TableRecord";
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Wrp from "../../../hoc/Wrp/Wrp";
import ViewPort from '../../../hoc/ViewPort';
import * as ShipConstants from '../../../Global/Constants';
import { callGET, callPOST, callDELETE } from '../../../Utils/ApiUtil';
import CreateNew from './CreateNew';
import Icons from '../../../Components/Icons/Icons';
import moment from 'moment';
import {isSet} from '../../../Utils/CommonFunctions';
import {getDateFormat, getUserInfo} from '../../../Utils/UserFunctions';

class RateConfig extends Component{
  constructor(props) {
    super(props);
    this.state = {
      isCreateNewModal:false,
      rateSheets : [],
      serviceList : [],
      apiListOptions:[],
      auotmationListOptions:[],
      referenceConfigOptions:[],
      rateConfigList : [],
      violations : {},
      new_fields : {
        id:'',
        name : '',
        expires_on : '',
        start_on : '',
        service : '',
        active : true,
        type : 'LOCAL',
        rate_sheet : [],
        desc : '',
        rate_config_automations:[],
        reference_rateconfig_id:'',
        rate_configuration_apis:[]
      },
      tableRecords:{
        tableHead:[
          {
            name:"Action",
            type:"Actions",
            isShow:true,
            attributes:{
                style:{width: "75px"}
            }
          },{
            name:"Name",
            type:"NoHref",
            isShow:true,

          },
          {
            name:"Start On",
            type:"Text",
            isShow:true,
          },
          {
            name:"Expires On",
            type:"Text",
            isShow:true,
          },
          {
            name:"Rates Active In Live",
            type:"Text",
            isShow:true,
          },
          {
            name:"Calculate Rates",
            type:"HtmlWithLink",
            isShow:true,
          }
        ],
        tableData:[], 
        pagination:{
          page:0,
          orderBy:'',
          perPage:10,
          direction:'DESC',
          totalRecords:0,
          search:''
        }
      }
    }
  }

  
  goBackHistory = ()=>{
    this.props.history.goBack()
  }
  componentWillMount() {
    const params = this.props.match.params;
    this.rateConfigList(this.state.tableRecords.pagination);
    this.fetchRateConfigList();
    this.rateSheetsList();
    this.fetchApiClientList();
    this.fetchAutomationList();
    // this.serviceList(params.carrierId);
  }
  componentDidUpdate(){
    // console.log(this.state);
  }

  // createNewChangeHandler = (e) => {
  //   const {name,value} = e.target;
  //   const updateState = {...this.state}
  //   if(name==='active') {
  //     updateState['new_fields'][name] = e.target.checked;
  //   }else {
  //     updateState['new_fields'][name] = value;  
  //   }

  //   if(this.state.violations) {
  //     let viol = this.state.violations;
  //     if(name === 'service') {
  //       viol = deleteViolationsMsg('serviceId',this.state.violations);
  //     }
  //     updateState['violations'] = viol;
  //   }
    
  //   console.log('Violations',updateState['violations']);
  //   this.setState(updateState);
  // }

  createNewValueUpdateHandler = (name,value,fieldName) => {
    const {new_fields,violations} = this.state;
    this.setState({
      new_fields:{
        ...new_fields,
        [name]:value
      },
      violations:{
        ...violations,
        [fieldName]:''
      }
    })
    // if(this.state.violations) {
    //   let viol = this.state.violations;
    //   if(name === 'rate_sheet') {
    //     viol = deleteViolationsMsg('rateSheetIds',this.state.violations);
    //   }
    //   updateState['violations'] = viol;
    // }
    // console.log('new_fields',updateState['new_fields'])
    // this.setState(updateState);
  }

  saveHandler = () => {
    this.props.Loader();
    //const params = this.props.match.params;
    const fields = this.state.new_fields;
    let rateSheetVal = [];
    if(fields.rate_sheet) {
      fields.rate_sheet.map((arr,i) => {
        rateSheetVal.push(arr.value);
      })
    }
    let rate_config_apis = isSet(fields.rate_configuration_apis,[]).map((itm)=>{
      return{
        api_collection_id:itm.value,
        api_collection_name:itm.label
      }
    })
    let payload = {
      name: fields.name,
      //carrier_id: params.carrierId,
      rate_type: fields.type,
      service_id: fields.service,
      start_date: fields.start_on,
      end_date: fields.expires_on,
      version_number: 1,
      is_active: fields.active,
      rate_sheet_ids: rateSheetVal,
      description:fields.description,
      // rate_config_automations:rate_config_auto,
      rate_configuration_apis:rate_config_apis,
      reference_rateconfig_id:fields.reference_rateconfig_id
    }
    if(fields.id) {
      payload = {
        ...payload,
        id : fields.id
      }
    }
    callPOST("rates/configurations/create",payload)
      .then(response => {
        this.props.Loader(false);
        console.log(response);
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.props.succMessage(responseData.message);
          this.toogleCreateNewHandler();
          this.rateConfigList(this.state.tableRecords.pagination);
        }else if(responseData.code===400){
          const violations = responseData.violations;
              let updateValidations = {};
              violations.map((fields)=>{
                  updateValidations = {
                      ...updateValidations,
                      [fields.field_name]:fields.message
                  }
              });
            this.setState({violations:updateValidations});
            if(violations.length===0){
              this.props.failMessage(responseData.message);
            }else{
              let violationMsg;
              violations.map((msg)=>{
                 violationMsg =  msg.message;
              })
              this.props.failMessage(violationMsg);              
            }
        }else{
          this.props.failMessage(responseData.message);
        }
      })
      .catch(err => {
        this.props.Loader(false);
        this.props.failMessage("Error occured");
        console.log(err);
      })
  }


  render(){
    const params = this.props.match.params;
    const {isCreateNewModal,isUploadSheet} = this.state;
    const breadCrumbs =   this.getAndSetBreadCrumbs(params);
      return (
          <Wrp>
              <BreadCrumbs 
                  breadCrumbsList={breadCrumbs} />
            <ViewPort backgroundColor={`transparent`}>
               <div className="outerPort">
                <TableRecord 
                  tableRecords={this.state.tableRecords} 
                  recordsChangeHandler={this.rateConfigList}
                 />
              </div>
              
            </ViewPort>
            <CreateNew
              {...this.props}
              curState={this.state}
              modelOpen={this.state.isCreateNewModal}
              toggleModel={this.toogleCreateNewHandler}
              // changeHandler={this.createNewChangeHandler}
              valueUpdateHandler={this.createNewValueUpdateHandler}
              saveHandler={this.saveHandler}
            />
          </Wrp>
        
        );
  }

  toogleCreateNewHandler = ()=>{
    const {isCreateNewModal} = this.state;
    // this.setState({isCreateNewModal:!isCreateNewModal})
    this.setState({isCreateNewModal:!isCreateNewModal,new_fields : {
        id:'',
        name : '',
        expires_on : '',
        start_on : '',
        service : '',
        active : true,
        type : 'LOCAL',
        rate_sheet : [],
        desc : ''
      }})
      this.setState({
        violations:{}
      })
  }

  toogleUploadSheetHandler = ()=>{
    const {isUploadSheet} = this.state;
    this.setState({isUploadSheet:!isUploadSheet})
  }

  rateSheetsList = async() => {
    const params = this.props.match.params;
    const queryString = '?query=&page=&orderBy=&size=99999999&direction=';
    await callGET("rates/sheets/list"+queryString)
    .then(response => {
      const responseData = response.data;
      const updateState = {...this.state}
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        updateState['rateSheets'] = responseData.data.content;
      }else {
        updateState['rateSheets'] = [];
      }
      this.setState(updateState);
    }, (error) => {
      this.props.failMessage("Something went wrong..");
    })
  }

  fetchApiClientList = ()=>{
    const queryString = '?query=&page=&orderBy=&size=200&direction=';
    callGET("api-client/list"+queryString)
    .then(response => {
      const responseData = response.data;
      if(responseData.code===200){  
        let apiListData = responseData.data.content;
        let options = apiListData.map((item,index)=>{
           return {
            value: item.id,
            label: item.collection_name,
          }
        })
        this.setState({apiListOptions:options});
      }
    }, (error) => {
      // this.props.failMessage("Something went wrong..");
    })
  }
    fetchAutomationList = async ()=>{
        const userInfo=getUserInfo();
         const page = 0; 
        const orderBy = '';
        const perPage = 9999999; 
        const direction = ''; 
        const search = '';
        const header = { 'Content-Type': 'application/json' };
        const queryString = '?query=' + search + '&page=' + page + '&orderBy=' + orderBy + '&size=' + perPage + '&direction=' + direction;
        const body = {
          'organization_id':userInfo.data.org_id,
          'user_id': "",
        };
       await callPOST("automations-process/paginated-search" + queryString, body, header)
       
    .then(response => {
      const responseData = response.data;
      if(responseData.code===200 && responseData!==undefined){  
        let automationListData = isSet(isSet(responseData,{data:{}}).data,{content:[]}).content;
        let options = automationListData.map((item,index)=>{
           return {
            value: item.id,
            label: item.name,
          }
        })
        this.setState({auotmationListOptions:options});
      }
    }, (error) => {
      // this.props.failMessage("Something went wrong..");
    })
  }

  serviceList = (id) => {
    const queryString = '?query=&page=&orderBy=&size=99999999999&direction=';
    callGET("table-data-engine/"+id+"/services")
    .then(response => {
      const responseData = response.data;
      const updateState = {...this.state}
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        updateState['serviceList'] = responseData.data;
      }else {
        updateState['serviceList'] = [];
      }
      this.setState(updateState);
    }, (error) => {
      this.props.failMessage("Something went wrong..");
    })
  }

  getAndSetBreadCrumbs = (params)=>{
    return {
      backHistory : [{
        // href:"/layouts/"+params.windowName+"/"+params.windowId+"/list/"+params.layoutId,
        // name:"Carrier"
        href : "/settings",
        name:"Settings"
        }],
      pageTitle:"Calculation List",
      buttonList:[
      /*{
        href:"/layouts/"+params.windowName+"/"+params.windowId+"/detailView/"+params.layoutId+"/"+params.carrierId,
        name:<span><i className="fas fa-chevron-left d-sm-block d-md-none"></i> <span className="d-sm-none d-md-block d-none"> Back </span></span>,
        attributes:{
          className:"btn border-default btn-border"
        },
        type:"cancel"
       },*/
       {
        name:<span className="d-sm-none d-md-block d-none"> Add New </span>,
        type:"addNew",
        clickHandler:this.toogleCreateNewHandler,
        attributes:{
          className:"btn primary_bg",
        }
      }
      ]
    }
  }

  editHandler = (data) => {
    let val = [];
    if(data.rate_sheet_map) {
      Object.keys(data.rate_sheet_map).map(function(key) {
        const value = {
          "value": key,
          "label": data.rate_sheet_map[key],
        }
        val.push(value);
      })    
    }
    
    

    const updateState = {...this.state}
    updateState['new_fields']['id'] = data.id;
    updateState['new_fields']['name'] = data.name;
    updateState['new_fields']['expires_on'] = moment(data.end_date).format('YYYY-MM-DD HH:mm:ss');//data.end_date;
    updateState['new_fields']['start_on'] = moment(data.start_date).format('YYYY-MM-DD HH:mm:ss');//data.start_date;
    updateState['new_fields']['service'] = data.service_id;
    updateState['new_fields']['active'] = data.is_active;
    updateState['new_fields']['type'] = data.rate_type;
    updateState['new_fields']['rate_sheet'] = val;
    updateState['new_fields']['description'] = data.description;
    updateState['new_fields']['reference_rateconfig_id'] = data.reference_rateconfig_id;
    updateState['new_fields']['rate_configuration_apis'] = data.rate_configuration_apis.map((itm)=>{
      return{
        label:itm.api_collection_name,
        value:itm.api_collection_id
      }
    })
    updateState['isCreateNewModal'] = true;
    // console.log(updateState['new_fields']);
    this.setState(updateState);
  }

  deleteconfig = (ide) => {
    // console.log("ide",ide);
   // let isDelete = window.confirm("are you sure you want to delete this data?");
   // if(isDelete) {
      this.props.Loader();
      callDELETE("rates/configurations/"+ide)
      .then(response => {
        this.props.Loader();
        // console.log(response);
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          // props.history.push("/workflow");
          this.props.succMessage(responseData.message);
          this.rateConfigList(this.state.tableRecords.pagination);
        }else {
          this.props.failMessage(responseData.message);
        }
      })
      .catch(err => {
        this.props.Loader();
        this.props.failMessage("Error occured");
        console.log(err);
      })
   // }
  }
  //RATE CONFIG LIST FOR REFERENCE
  fetchRateConfigList = () => {
    const params = this.props.match.params;
    const page = 0;//pagination.page; 
    const orderBy = '';//pagination.orderBy; 
    const perPage = '500';//pagination.perPage; 
    const direction = '';//pagination.direction; 
    const search = '';//pagination.search;
    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    //callGET("rates/configurations/list/"+params.carrierId+queryString)
    callGET("rates/configurations/list"+queryString)
    .then(res => {
      this.props.Loader(false);
      if(res.status===200){ 
        const response = res.data;
        if(response.code===200){
          let rateConfigListForRef = response.data.content.map((item,index)=>{
              return{
                id:item.id,
                name:item.name,
                index:index
              }
          })
          this.setState({
            referenceConfigOptions:rateConfigListForRef
          });
        }
      }else{
        this.setState({
          referenceConfigOptions:[]
        });
      }
    }, (error) => {
      // this.props.failMessage("Something went wrong..");
    })
  }
  //RATE CONFIG LIST 
  rateConfigList = (pagination) => {
    this.props.Loader();
    const params = this.props.match.params;
    const page = pagination.page; 
    const orderBy = pagination.orderBy; 
    const perPage = pagination.perPage; 
    const direction = pagination.direction; 
    const search = pagination.search;
    this.setState({
      tableRecords:{
        ...this.state.tableRecords,
        pagination:pagination
      }
    });
    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    //callGET("rates/configurations/list/"+params.carrierId+queryString)
    callGET("rates/configurations/list"+queryString)
    .then(res => {
      this.props.Loader(false);
      if(res.status===200){ 
        const response = res.data;
        if(response.code===200){
          // console.log(response.data);
          let updateTableData = response.data.content.map((item,index)=>{
              let start_date = moment(item.start_date).format(getDateFormat('DateTime'));
              let end_date = moment(item.end_date).format(getDateFormat('DateTime'));
              
              //const hrefData = "/shipping/"+params.windowName+"/"+params.windowId+"/rate-calculate/"+params.layoutId+"/"+params.carrierId+"/"+item.id;
              const hrefData = "/calculation/"+item.id;
              return {
              className:' ',
              data:{
                actions:[
                  {
                    attributes:{
                      className:"p-1"
                    },
                    //iconClass:"fas fa-pencil-alt third_dark_color",
                    svgIcon:"Edit",
                    clickHandler:this.editHandler.bind(this,item),
                    name:""
                  },
                  {
                    attributes:{
                      className:"p-1"
                    },
                    //iconClass:"fas fa-trash-alt primary_color",
                    svgIcon:"Delete",
                    clickHandler:this.deleteconfig.bind(this,item.id),
                    name:""
                  }
                  
                ],
                name: {
                  value : item.name
                },
                start_date:item.start_date ? start_date :"",
                end_date:item.end_date ? end_date :"",
                is_active:<span className="table_SvgIcon">
                            <i className={item.is_active === true ? "fas fa-check text-success fa-lg" : "fas fa-times text-danger fa-lg"}></i>
                          </span>,
                name11: {
                    href : hrefData,
                    value : <Icons iconType="CalculateRates" />
                  }
              }
            }
            })
            
          const totalRecords = response.data.total_elements;
          this.setState({status:200,rateConfigList: response.data.content,tableRecords:{
            tableData:{data:updateTableData,status:200},
            tableHead:this.state.tableRecords.tableHead ,
            pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
          }});
        }else{
            const totalRecords = 0;//response.data.totalElements;
            this.setState({status:200, tableRecords:{
                tableData:[],
                tableHead:this.state.tableRecords.tableHead ,
                pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
            }});
            }
      }else{
          const totalRecords = 0;//response.data.totalElements;
          this.setState({status:200, tableRecords:{
            tableData:[],
            tableHead:this.state.tableRecords.tableHead ,
            pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
          }});
      }

    }, (error) => {
      this.props.Loader(false);
      this.props.failMessage("Something went wrong..");
    })
  }
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : (bool) => dispatch(actions.loader(bool)),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))    
  };
}

export default
  connect(
    null, 
    mapDispatchToProps
  )(withRouter(RateConfig));